import CapacityReportPage from './capacityReportPage'
export default CapacityReportPage
